import { BaseDynamicFormElement } from './dynamic-form-base.class';
import { BaseDynamicFormElementInterface } from './base-dynamic-form-element.interface';

export class TextboxElement<T = string> extends BaseDynamicFormElement<T> {
  constructor(config: Partial<BaseDynamicFormElementInterface<T>>) {
    super({
      ...config,
      controlType: 'textbox',
    });
  }
}
